import { jsx as _jsx } from "react/jsx-runtime";
import { BodyContainer } from './Body.style';
const Body = ({ children }) => (_jsx(BodyContainer, { children: children }));
export default Body;
